var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wechsel_zu_der_ZWO_Gro\\xDFkundennummer",
    "data-name": "Wechsel zu der ZWO Gro\\xDFkundennummer",
    transform: "translate(-6013 -6700)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(6013 6700)",
    fill: "#e8fcff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4551",
    "data-name": "Group 4551",
    transform: "translate(-3838.512 -811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "download_9_",
    "data-name": "download (9)",
    d: "M224.46,181.83v50h39.024v-37.8H252.508a1.267,1.267,0,0,1-1.22-1.22V181.83Zm29.268,1.22v8.536h8.536Zm-22.561,7.927h12.195a1.22,1.22,0,1,1,0,2.439H231.167a1.22,1.22,0,1,1,0-2.439Zm0,9.756h25.609a1.22,1.22,0,1,1,0,2.439H231.167a1.22,1.22,0,0,1,0-2.439Zm0,9.756h25.609a1.22,1.22,0,1,1,0,2.439H231.167a1.22,1.22,0,0,1,0-2.439Zm0,9.756h25.609a1.22,1.22,0,1,1,0,2.439H231.167a1.22,1.22,0,1,1,0-2.439Z",
    transform: "translate(9657.54 7354.17)",
    fill: "#00c4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M10109.383,7545.626v8.482h8.455Z",
    transform: "translate(-198.107 -8.387)",
    fill: "#5f5f5f",
    stroke: "#5f5f5f",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon_document.62462d4ed57bf2910ad645c4dcd05768.svg";
export { ForwardRef as ReactComponent };